module.exports = __webpack_public_path__ + "static/media/Ombro.7c80716c.png";